/*eslint-disable*/export const messages=JSON.parse("{\"common.sponsorLabel\":\"Advertiser content\"}");